
import './App.css';
import Login from "./Pages/Login/Login";
import AllUsers from "./Pages/AllUsers/AllUsers";
import Header from "./Components/Header/Header";
import AddPost from "./Pages/AddPost/AddPost";
import { Routes, Route } from "react-router-dom";
import { useGlobalContext } from "./context";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AddUser from "./Pages/AddUser/AddUser";
import SchedulePost from "./Pages/SchedulePost/SchedulePost";
import AllPosts from "./Pages/AllPosts/AllPosts";
import DayPostsData from "./Pages/AllPosts/DayPostsData";
import Schedule from "./Pages/Schedule/Schedule";
import EditSchedule from "./Pages/Schedule/EditSchedule";
import Completed from "./Pages/AddPost/Completed";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import EditUser from "./Pages/EditUser/EditUser";
import MonthlyPosts from "./Pages/MonthlyPosts/MonthlyPosts";

function App() {

    const {
        navbarData
    } = useGlobalContext();

    const navigate = useNavigate();
    const [user, setUser] = useState(false);

    useEffect(() => {
        if (window.name) {
            setUser(true);
        }
        else {
            setUser(true);
        }
    }, []);

    useEffect(() => {
        const activePage = navbarData.find(item => item.active === true);
        if (activePage) {
            if (activePage.text === "ADD A USER") {
                navigate("/add-user")
            }
            else if (activePage.text === "ALL USERS") {
                navigate("/");
            }
            else if (activePage.text === "ADD A POST") {
                navigate("/add-post")
            }
            else if (activePage.text === "SCHEDULE A POST") {
                navigate("/schedule-post");
            }
            else if (activePage.text === "ALL POSTS") {
                navigate("/all-posts")
            }
            else if (activePage.text === "SCHEDULE") {
                navigate("/schedule");
            }
            else if (activePage.text === "MONTHLY POSTS") {
                navigate("/monthly-posts");
            }
        }
        else {
            navigate('/edit-user');
        }
    }, [navbarData]);
    
    // localStorage.clear()

    return (
        <div className="App">
            {
                !user ?
                    <Login/>
                    :
                    <LocalizationProvider dateAdapter = { AdapterDayjs }>
                        <Header/>
                        <Routes>
                            <Route path = "/" element = { <AllUsers/> } />
                            <Route path = "/add-user" element = { <AddUser/> } />
                            <Route path = "/add-post" element = { <AddPost/> } />
                            <Route path = "/schedule-post" element = { <SchedulePost /> } />
                            <Route path = "/all-posts" element = { <AllPosts/> } />
                            <Route path = "/day-posts" element = { <DayPostsData/> } />
                            <Route path = "/schedule" element = { <Schedule/> } />
                            <Route path = "/edit-schedule" element = { <EditSchedule/> } />
                            <Route path = "/edit-user" element = { <EditUser/> } />
                            <Route path = "/monthly-posts" element = {<MonthlyPosts/>}/>
                        </Routes>
                        <Completed/>
                    </LocalizationProvider>
            }
        </div>
    );
}

export default App;
